import { UnitConversionService } from '../../unit-conversion-service';

export const convertWeight = (weight, unit) => {
  const validWeight = weight || {};
  return {
    value: UnitConversionService.convertValue(validWeight.value, validWeight.unit, unit),
    unit,
  };
};

/**
 * Calculates the appropriate weight value based on configureRatesModel and package data
 * @param {object} configureRatesModelWeight - Weight from the configureRatesModel
 * @param {object} combinedPackage - Combined package data
 * @param {string} defaultWeightUnit - Default weight unit to convert to
 * @returns {object} Converted weight object with value and unit
 */
export const calculateRateBrowserWeight = (configureRatesModelWeight, combinedPackage, defaultWeightUnit) => {
  // Prioritize weight from configureRatesModel if it exists and has a valid weight value
  const hasValidConfigWeight =
    configureRatesModelWeight && typeof configureRatesModelWeight.weight === 'number' && configureRatesModelWeight.weightUnit;

  return hasValidConfigWeight
    ? convertWeight(
        {
          value: configureRatesModelWeight.weight,
          unit: configureRatesModelWeight.weightUnit,
        },
        defaultWeightUnit,
      )
    : convertWeight(combinedPackage?.weight || { value: 0, unit: defaultWeightUnit }, defaultWeightUnit);
};
